// modules
import { createSelector } from 'reselect'

// utils
import { get } from 'lodash'

const referral = (state = {}) => get(state, ['referral'], {})

export const isAddReferralModalVisible$ = createSelector(
  referral,
  (referral = {}) => get(referral, ['isAddReferralModalVisible'], false)
)
